import { Component, OnInit, EventEmitter } from '@angular/core';
import { DialogComponent, DialogService } from 'ng2-bootstrap-modal';
import { CoinEventsService } from '../../../_services/coinevents.service';

@Component({
    selector: 'app-add-coin-events',
    templateUrl: './add-coin-events.component.html',
    styleUrls: ['./add-coin-events.component.css']
})

export class AddCoinEventsComponent extends DialogComponent<null, boolean> implements OnInit {

    model: any = {};
    loading = false;
    message: string;
    returnUrl: string;
    focusEventEmitter = new EventEmitter<boolean>();

    constructor(
        dialogService: DialogService, 
        private coinEventsService: CoinEventsService
    ) {
        super(dialogService);
    }

    ngOnInit() {
        this.model.isActive = true;
        this.model.listCoin = '';
    }

    ngAfterViewInit() {
        this.focusEventEmitter.emit(true);
    }

    add() {
        this.loading = true;
        this.message = '';
        this.model.coinName = $("#listCoin option[value='" + this.model.listCoin + "']").text();

        //use service to add model
        this.coinEventsService.add(this.model).subscribe(data => {
            if (data.error) {
                this.message = data.message;
            } else {
                this.close();
                this.result = true;
            }
        }, error => {
            this.message = error.json().message; 
            this.loading = false;
        }, () => {
            this.loading = false;
        })
    }

}



// WEBPACK FOOTER //
// C:/Users/El-Nino/Desktop/coin-alert-test/AngularCoinAlert/src/app/_components/coinevents/add-coin-events/add-coin-events.component.ts